// This file will contain the adapter classes for translatable paragraphs.
// Initially left empty, to be populated in the next step.
/**
 * Adapter for `ParagraphData` (from standard text) to conform to the `TranslatableParagraph` interface.
 */
export class TextParagraphAdapter {
    constructor(para) {
        this.para = para;
    }
    getId() {
        return this.para.id;
    }
    getContent() {
        return this.para.content;
    }
    getWords() {
        // Standard text paragraphs do not have word-level data.
        return undefined;
    }
    getIndex() {
        return this.para.index;
    }
}
/**
 * Adapter for `PreRenderedParagraph` (from PDFs) to conform to the `TranslatableParagraph` interface.
 */
export class PdfParagraphAdapter {
    constructor(para) {
        this.para = para;
    }
    getId() {
        return this.para.paragraphId;
    }
    getContent() {
        // The content is synthesized by joining the text of all words.
        return this.para.words.map(w => w.text).join(' ');
    }
    getWords() {
        return this.para.words;
    }
    getIndex() {
        return this.para.index;
    }
}
//# sourceMappingURL=paragraph.adapter.js.map